export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getOrCreateAccount: function getOrCreateAccount(account) {
            return JsonRPCService.send('pc', 'gateway/account', 'getOrCreateAccount', [account]);
        },
        getAccountDetails: function getAccountDetails(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountDetails', [accountNumber]);
        },
        updateAccountDetails: function updateAccountDetails(account) {
            return JsonRPCService.send('pc', 'gateway/account', 'updateAccountDetails', [account]);
        },
        getNotesForAccount: function getNotesForAccount(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getNotesForAccount', [accountNumber]);
        },
        createNoteForAccount: function createNoteForAccount(accountNumber, noteDTO) {
            return JsonRPCService.send('pc', 'gateway/account', 'createNoteForAccount', [accountNumber, noteDTO]);
        },
        getDocumentsForAccount: function getDocumentsForAccount(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getDocumentsForAccount', [accountNumber]);
        },
        getAvailableProductsForAccount: function getAvailableProductsForAccount(newSubmission) {
            return JsonRPCService.send('pc', 'gateway/account', 'getAvailableProductsForAccount', [newSubmission]);
        },
        getPotentialExistingAccounts: function getPotentialExistingAccounts(accountSearchCritera) {
            return JsonRPCService.send('pc', 'gateway/account', 'getPotentialExistingAccounts', [accountSearchCritera]);
        },
        getPolicyTransactionsForAccount: function getPolicyTransactionsForAccount(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getPolicyTransactionsForAccount', [accountNumber]);
        },
        getOpenPolicyTransactionsForAccount: function getOpenPolicyTransactionsForAccount(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getOpenPolicyTransactionsForAccount', [accountNumber]);
        },
        getOwnedBilledPoliciesForAccount: function getOwnedBilledPoliciesForAccount(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getOwnedBilledPoliciesForAccount', [accountNumber]);
        },
        getUnownedBilledPoliciesForAccount: function getUnownedBilledPoliciesForAccount(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getUnownedBilledPoliciesForAccount', [accountNumber]);
        },
        getAccountBillingInvoices: function getAccountBillingInvoices(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getInvoicesForAccount', [accountNumber]);
        },
        getAccountClaims: function getAccountClaims(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountClaims', [accountNumber]);
        },
        getAccountsForCurrentUser: function getAccountsForCurrentUser(createdInLastXDays, queryOptions, queryParameters) {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountsForCurrentUser', [createdInLastXDays, queryOptions, queryParameters]);
        },
        getPersonalAccountsForCurrentUser: function getPersonalAccountsForCurrentUser(createdInLastXDays, queryOptions, queryParameters) {
            return JsonRPCService.send('pc', 'gateway/account', 'getPersonalAccountsForCurrentUser', [createdInLastXDays, queryOptions, queryParameters]);
        },
        getCommercialAccountsForCurrentUser: function getCommercialAccountsForCurrentUser(createdInLastXDays, queryOptions, queryParameters) {
            return JsonRPCService.send('pc', 'gateway/account', 'getCommercialAccountsForCurrentUser', [createdInLastXDays, queryOptions, queryParameters]);
        },
        getAccountsForProducerCode: function getAccountsForProducerCode(createdInLastXDays, queryOptions, producerCode) {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountsForProducerCode', [createdInLastXDays, queryOptions, producerCode]);
        },
        getPersonalAccountsForProducerCode: function getPersonalAccountsForProducerCode(createdInLastXDays, queryOptions, producerCode) {
            return JsonRPCService.send('pc', 'gateway/account', 'getPersonalAccountsForProducerCode', [createdInLastXDays, queryOptions, producerCode]);
        },
        getCommercialAccountsForProducerCode: function getCommercialAccountsForProducerCode(createdInLastXDays, queryOptions, producerCode) {
            return JsonRPCService.send('pc', 'gateway/account', 'getCommercialAccountsForProducerCode', [createdInLastXDays, queryOptions, producerCode]);
        },
        getRecentlyViewedAccounts: function getRecentlyViewedAccounts() {
            return JsonRPCService.send('pc', 'gateway/account', 'getRecentlyViewedAccounts', []);
        },
        addRecentlyViewedAccounts: function addRecentlyViewedAccounts(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'addRecentlyViewedAccounts', [accountNumber]);
        },
        getAccountJobsForCurrentUser: function getAccountJobsForCurrentUser(createdInLastXDays, queryOptions, searchParam) {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountJobsForCurrentUser', [createdInLastXDays, queryOptions, searchParam]);
        },
        getAccountBillingData: function getAccountBillingData(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountBillingData', [accountNumber]);
        },
        getAccountJobsSummariesForCurrentUser: function getAccountJobsSummariesForCurrentUser(createdInLastXDays, producerCode) {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountJobsSummariesForCurrentUser', [createdInLastXDays, producerCode]);
        },
        sendMail: function sendMail(newContent) {
            return JsonRPCService.send('pc', 'gateway/account', 'sendMail', [newContent]);
        },
        getStates: function getStates(country) {
            return JsonRPCService.send('pc', 'gateway/account', 'getStates', [country]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/AccountService.js
// module id = 1782
// module chunks = 0